import React, { useEffect, useState } from 'react'
import { FaBookOpenReader, FaUser } from 'react-icons/fa6'
import { IoIosArrowDropright, IoMdLock } from 'react-icons/io'
import light_logo from "../../assets/logo_light.png"
import axios from 'axios'
import { BASE_URL } from '../../utils/endpoints'
import { toast } from 'react-toastify'
import { Navigate, useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../context/stateContext'
import { useAuth } from '../../context/Auth'


const UserSession = () => {
  const navigate = useNavigate()
  const { requestWithAuth } = useAuth();
  const [branches, setBranches] = useState([]);
  const [sessionData, setSessionData] = useState({})

  const handleChange = (e) =>{
    setSessionData({...sessionData, [e.target.name]: e.target.value})
  }


  const fetchBranches = async () => {
    
    try {
      const data = await requestWithAuth(`/company/branches/?pageSize=100`, "GET")
      setBranches(data?.results);
    } catch (error) {
      console.error("Error fetching users data:", error)
    } finally {
      
    }
  }

  const createSession = async (e) => {
    e.preventDefault()
    
    try {
      const body = JSON.stringify(sessionData)
      const data = await requestWithAuth(`/users/session/`, "POST", body,{
        "Content-Type":"application/json"
      })
      document.cookie = `activesession=${data.id}; SameSite=Strict; Secure; path=/`
      if(data?.role === "Cashier"){
        window.location.href = '/pos/cashier'
      }else{
        window.location.href = "/dashboard"
      }
    } catch (error) {
      console.error("Error fetching users data:", error)
    } finally {
      
    }
  }

  useEffect(()=>{
    fetchBranches();
  },[])

  return (
    <div>
        <div className='px-[20px] bg-[#37474F] min-h-[46px] flex items-center'>
            <img src={light_logo} alt="" className='h-[16px]' />
        </div>
        <div className='min-h-[676.4px] py-[60px]'>
            <form onSubmit={(e)=>createSession(e)} className='mx-auto mb-[20px] w-[320px] border border-[#ddd] bg-white rounded-[3px] p-[20px]'>
                <div className=" text-[#333] flex flex-col items-center">
                    <div className="text-center">
                        <div className="text-center m-[10px] p-[20px] border-[3px] border-[#90A4AE] rounded-full">
                            <FaBookOpenReader className='text-[#90A4AE] text-[32px]' />
                        </div>
                    </div>
                    <div className="text-center mb-[20px] mt-[10px]">
                        <h5 className='text-[17px]'>
                            Session Selector
                        </h5>
                        
                    </div>
                </div>
                <div className="mb-[20px]">
                    <label htmlFor="">User branch</label>
                    <select required onChange={(e)=> handleChange(e)} name="branch" id="" className='font-[400] outline-none px-[12px] py-[7px] border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px]' >
                      <option value="">Select Branch</option>
                      {branches.map((branch, index) => (
                        <>
                          {
                            !branch?.is_head_office && (
                            <option key={index} value={branch.id}>
                              {branch.name}
                            </option>
                            )
                          }
                        </>
                      ))}
                    </select>
                    
                    
                </div>
                <div className="mb-[20px]">
                    <label htmlFor="">User Session</label>
                    <select required onChange={(e)=>handleChange(e)} name="session"  id="" className='font-[400] outline-none px-[12px] py-[7px] border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px]' >
                      <option value="">
                        Select Session
                      </option>
                      <option value="Morning">
                        Morning
                      </option>
                      <option value="Evening">
                        Evening
                      </option>
                      
                    </select>
                    
                    
                </div>
                <button className="bg-[#2196F3] mb-[20px] border border-[#2196F3] text-white rounded-[3px] h-[36px] w-full py-[7px] px-[12px] flex items-center justify-center gap-2">
                    Submit Session <IoIosArrowDropright />
                </button>
                
            </form>
        </div>
    </div>
  )
}

export default UserSession